module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red\"> The channel in which this order came from will not be updated to reflect the removal of this product in which case the the order will stay in a partial status. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/removeProductModalBody.html
// module id = 1369
// module chunks = 1